import { MOBILE_MAX_WIDTH } from 'Src/me/pages/guest/proposals/new/consts';
import { debounce } from 'Src/me/pages/guest/proposals/new/utils';

const SET_TARGET_SELECTOR = '.js-adjustMainContentsHeight-set-target';
const HEADER_TARGET_SELECTOR = '.js-adjustMainContentsHeight-header-target';

export const adjustMainContentsHeight = () => {
  const setTarget = document.querySelector<HTMLDivElement>(SET_TARGET_SELECTOR);
  const headerTarget = document.querySelector<HTMLElement>(HEADER_TARGET_SELECTOR);

  if (!setTarget || !headerTarget) return;

  // メインコンテンツの高さを設定する処理
  const setMainContentsHeight = debounce(() => {
    const isMobileView = window.innerWidth <= MOBILE_MAX_WIDTH;
    const headerHeight = headerTarget.clientHeight;

    if (isMobileView) {
      setTarget.style.minHeight = `calc(100vh - ${headerHeight}px)`;
    } else {
      setTarget.style.minHeight = '';
    }
  }, 200);

  setMainContentsHeight(); // 初期値判定
  window.addEventListener('resize', setMainContentsHeight); // イベント登録
};
